import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useParams, useHistory } from 'react-router-dom';
import { Container, Spinner, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { toast } from 'react-toastify';

import Breadcrumb from 'components/App/Breadcrumb';
import Meta from 'components/App/Meta';
import Loading from 'components/App/Loading';
import DiscoverProvinceDetails from 'components/DiscoverProvinceDetails';
import ModalRequestAction from 'components/Modals/ModalRequestAction';
import discoverProvince from 'api/discoverProvince';
import images from 'assets/images';
import ENDPOINT from 'constants/endPoint';

import styles from './DiscoveryProvincesDetails.module.scss';
import ProvinceDetails from './ProvinceDetails';

const TITLE = 'Quản lý điểm đến';

const BREADCRUMB_LIST = [
  {
    name: 'Điểm khám phá',
    isActive: false,
    link: '',
  },
  {
    name: 'Quản lý điểm đến',
    isActive: false,
    link: '',
  },
  {
    name: 'Chi tiết điểm đến',
    isActive: true,
    link: '',
  },
];

function DiscoveryProvincesDetails(props) {
  const { id } = useParams();
  const history = useHistory();

  const {
    provinceDetailsLoading,
    provinceDetails,

    actionGetDiscoveryProvinceDetails,
    actionCleanupDiscoverProvinceDetails,
    actionGetProvincesName,
    actionCleanupProvincesName,
  } = props;

  const [isOpenEditModal, setIsOpenEditModal] = useState(false);
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  React.useEffect(() => {
    actionGetDiscoveryProvinceDetails(id);
    actionGetProvincesName();
    return () => {
      actionCleanupDiscoverProvinceDetails();
      actionCleanupProvincesName();
    };
  }, [
    actionCleanupDiscoverProvinceDetails,
    actionCleanupProvincesName,
    actionGetDiscoveryProvinceDetails,
    actionGetProvincesName,
    id,
  ]);

  const handleConfirmDelete = async () => {
    try {
      setDeleteLoading(true);
      await discoverProvince.deleteDiscoverProvince(id);
      toast.success('Xoá điểm đến thành công');
      setIsOpenDeleteModal(false);
      history.push(ENDPOINT.MANAGER_DISCOVERY_DESTINATION || '/manager-discovery/destination');
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Xoá điểm đến thất bại');
    } finally {
      setDeleteLoading(false);
    }
  };

  return (
    <div className={`page-content ${styles.Page}`}>
      <Meta name={TITLE} />

      <Container fluid>
        <Breadcrumb pageTitle={TITLE} breadcrumbList={BREADCRUMB_LIST} />

        <Loading loading={provinceDetailsLoading} loaderOnPage />

        {provinceDetailsLoading && (
          <div className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
            <Spinner />
          </div>
        )}

        {!provinceDetailsLoading && !provinceDetails._id && (
          <p>Không tìm thấy điểm đến</p>
        )}

        {provinceDetails._id
          && (
            <ProvinceDetails
              provinceDetails={provinceDetails}
              onEdit={() => setIsOpenEditModal(true)}
              onDelete={() => setIsOpenDeleteModal(true)}
            />
          )}
      </Container>

      <Modal
        isOpen={isOpenEditModal}
        toggle={() => setIsOpenEditModal(false)}
        size="lg"
        centered
      >
        <ModalHeader toggle={() => setIsOpenEditModal(false)}>
          Chỉnh sửa điểm đến
        </ModalHeader>
        <ModalBody>
          <DiscoverProvinceDetails
            isCreate={false}
            provinceId={id}
            provinceDetails={provinceDetails}
            callback={() => {
              setIsOpenEditModal(false);
              actionGetDiscoveryProvinceDetails(id);
            }}
          />
        </ModalBody>
      </Modal>

      <ModalRequestAction
        isOpen={isOpenDeleteModal}
        icon={images.modalGarbageCan?.default || images.modalGarbageCan}
        textRequest={'Bạn có chắc chắn muốn xoá \n điểm đến này không?'}
        onToggle={() => setIsOpenDeleteModal(false)}
        onCloseModal={() => setIsOpenDeleteModal(false)}
        onConfirm={handleConfirmDelete}
        isLoadingConfirm={deleteLoading}
      />
    </div>
  );
}

DiscoveryProvincesDetails.propTypes = {
  provinceDetailsLoading: PropTypes.bool.isRequired,
  provinceDetails: PropTypes.instanceOf(Object).isRequired,
  actionCleanupDiscoverProvinceDetails: PropTypes.func.isRequired,
  actionGetDiscoveryProvinceDetails: PropTypes.func.isRequired,
  // provincesNameLoading: PropTypes.bool.isRequired,
  // provincesName: PropTypes.instanceOf(Array).isRequired,
  actionGetProvincesName: PropTypes.func.isRequired,
  actionCleanupProvincesName: PropTypes.func.isRequired,
};

export default DiscoveryProvincesDetails;
